export default {
  STICKY (state, data) {
    if (data && data.length) {
      state.stickies = data.reverse()
    }
    state.stickies.forEach((post) => {
      state.posts.unshift(post)
    })
  },
  POSTS (state, { data, headers }) {
    state.posts = data
    state.totalPosts = parseInt(headers['x-wp-total'])
    state.totalPages = parseInt(headers['x-wp-totalpages'])
  },
  POST (state, post) {
    state.post = post[0] ? post[0] : post
  },
  PAGE (state, page) {
    state.page = page[0] ? page[0] : page
  },

  EXPAND (state, id = null) {
    if (id === state.expanded) {
      state.expanded = null
    } else {
      state.expanded = id
    }
  },

  FROM (state, from) {
    state.from = from
  }
}
